import React, {useEffect, useState} from "react";
import {BasicProps} from "../Main";
import {Grid} from "@mui/material";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import {SamaggiFormSection} from "../Components/SamaggiForm";
import logo from "../assets/logo.png";
import {useNavigate} from "react-router-dom";

export const Home: React.FC<BasicProps> = (props) => {
    const [menuItems, setMenuItems] = useState([])
    const [name, setName] = useState("");
    const [team, setTeam] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        props.setShowCover(true);
        load() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function load() {
        const mi = localStorage.getItem("options");
        let registered = false;

        if (mi !== null) {
            setMenuItems(JSON.parse(mi));
        } else {
            registered = true;

            setTimeout(() => {
                load();
            }, 200)
        }

        const userData = localStorage.getItem("userData");
        if (userData !== null) {
            const data = JSON.parse(userData);
            setName(`${data["name"]["firstName"]} ${data["name"]["lastName"]}`)
            setTeam(`${data["team"]} — ${data["role"]}`)
        } else if (!registered) {
            registered = true;

            window.addEventListener("storage", () => {
                setTimeout(() => {
                    load();
                }, 200)
            })
        }

        if (!registered) {
            console.log("HIDE!");
            props.setShowCover(false);
        }
    }


    function move(to: string) {
        const r = new RegExp('^(?:[a-z+]+:)?//', 'i');

        if (r.test(to)) {
            window.location.href = to
        } else {
            navigate(to)
        }
    }

    return (
        <>
            <Grid container direction={"column"} spacing={3}>
                <Grid item container direction={"column"} spacing={2}>
                    <Grid item container direction={"row"} alignContent={"center"}>
                        <img src={logo} style={{maxWidth: "40%", margin: "auto"}} alt={"Samaggi Samagom Logo"}/>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography large bold center>Welcome to Staff Portal</SamaggiTypography>
                    </Grid>
                    <Grid item container direction={"column"}>
                        <Grid item>
                            <SamaggiTypography center>{name}</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center small italic colour={Colours.samaggiBlue}>{team}</SamaggiTypography>
                        </Grid>
                    </Grid>
                </Grid>
                <SamaggiFormSection label={"Menu"}>
                    <Grid item container direction={"row"} spacing={2}>
                        {menuItems.map((item) => (
                            <Grid item xs={12} md={6}>
                                <SamaggiButton fullWidth colour={Colours.white} hoverColour={"#004225"} textColour={Colours.samaggiBlue} hoverTextColour={Colours.white} style={{height: "80px", border: `2.5px solid #004225`}} onClick={() => {move(item["optionPath"])}}>{item["optionTitle"]}</SamaggiButton>
                            </Grid>
                        ))}
                    </Grid>
                </SamaggiFormSection>
            </Grid>

        </>
    )

}
